;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export function preventTourHostOutsideEvent({
	isTourHostOpen,
	event,
}: {
	isTourHostOpen: boolean;
	event: { preventDefault: () => void };
}) {
	if (isTourHostOpen) {
		event.preventDefault();
	}
}
